import React, { useId, useState } from 'react';

/**
 * Collapsible form section for long admin create/edit forms.
 * defaultOpen: first sections open by default; later ones can start collapsed.
 */
const AdminFormSection = ({
  title,
  children,
  defaultOpen = true,
  hint = null
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const labelId = useId();

  return (
    <section className={`admin-form-section${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="admin-form-section-header"
        id={labelId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="admin-form-section-title">{title}</span>
        <span className="admin-form-section-chevron" aria-hidden="true">
          {open ? '▾' : '▸'}
        </span>
      </button>
      {open && (
        <div
          className="admin-form-section-body"
          id={panelId}
          role="region"
          aria-labelledby={labelId}
        >
          {hint && <p className="admin-form-section-hint">{hint}</p>}
          {children}
        </div>
      )}
    </section>
  );
};

export default AdminFormSection;
